import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StoryblokImage } from '../../models';
import { SB_FORMAT_PARAM } from '../../constants';
import { GtmDatalayerService } from '~shared/services/gtm-datalayer.service';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-headLine-banner',
  templateUrl: './headLine-banner.component.html',
  styleUrls: ['./headLine-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadLineBannerComponent {
  @Input() headline: string;
  @Input() banner: StoryblokImage;

  sbFormatParam = SB_FORMAT_PARAM;
  market: string;

  constructor(private gtmDatalayerService: GtmDatalayerService) {
    this.market = getCountryDomainCode();
  }

  initializeHeadlineBanner(): void {
    this.gtmDatalayerService.gtagEvent({
      event: GATrackingEventType.SE_HEADLINE_BANNER_VIEWED,
      GA_eventname: GaTrackingEventName.Interaction,
      action: GaTrackingEventAction.HEADLINE_BANNER_VIEWED,
      label: this.headline || '',
    });
  }
}
